import { GET_JOB_APPLICATIONS } from '../../endpoints';
import makeAuthenticatedRequest from '../base-api';

const jobApplicationsQueryKey = ['applications'];

const getJobApplications = async ({
  startRow,
  endRow,
  filterModel,
  sortModel,
  search,
  category,
  status,
  includeStatusCounts,
  includeFilterCounts,
  industries,
  languages,
  applicationStatuses,
  screeningStatuses,
}: {
  startRow: number;
  endRow: number;
  filterModel: any;
  sortModel: any;
  search: string;
  category: string;
  status: string;
  includeStatusCounts?: boolean;
  includeFilterCounts?: boolean;
  industries?: string[];
  languages?: string[];
  applicationStatuses?: string[];
  screeningStatuses?: string[];
}) => {
  try {
    const params = new URLSearchParams({
      startRow: String(startRow),
      endRow: String(endRow),
      filterModel: JSON.stringify(filterModel || {}),
      sortModel: JSON.stringify(sortModel || []),
      search: search || '',
      category: category || '',
      status: status || '',
      includeStatusCounts: String(includeStatusCounts || false),
      includeFilterCounts: String(includeFilterCounts || false),
    });

    if (industries?.length) params.set('industries', JSON.stringify(industries));
    if (languages?.length) params.set('languages', JSON.stringify(languages));
    if (applicationStatuses?.length) params.set('applicationStatuses', JSON.stringify(applicationStatuses));
    if (screeningStatuses?.length) params.set('screeningStatuses', JSON.stringify(screeningStatuses));

    const response = await makeAuthenticatedRequest(
      `${GET_JOB_APPLICATIONS}?${params.toString()}`,
      {
        method: 'GET',
      }
    );

    const result = await response.json();

    if (!result.success) {
      throw new Error(result.message);
    }

    return result;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export { getJobApplications, jobApplicationsQueryKey };
